export const hostname = process.env.VUE_APP_PAPI_HOST
export const env = process.env.NODE_ENV
